const LOAD_DATA_JOB_DESTINATIONS_GROUP           = 'LOAD_DATA_JOB_DESTINATIONS_GROUP'
const LOAD_DATA_JOB_DESTINATIONS_GROUP_SUCCESS   = 'LOAD_DATA_JOB_DESTINATIONS_GROUP_SUCCESS'
const LOAD_DATA_JOB_DESTINATIONS_GROUP_FAILED    = 'LOAD_DATA_JOB_DESTINATIONS_GROUP_FAILED'
const UNMOUNT_DATA_JOB_DESTINATIONS_GROUP        = 'UNMOUNT_DATA_JOB_DESTINATIONS_GROUP'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const jobDestinationGroupReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_JOB_DESTINATIONS_GROUP:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_JOB_DESTINATIONS_GROUP_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_JOB_DESTINATIONS_GROUP_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_JOB_DESTINATIONS_GROUP:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default jobDestinationGroupReducer;